import React from "react";
import { IconProps } from "./IconProps";

const PlusCircleIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 2C8.41775 2 6.87103 2.46919 5.55544 3.34824C4.23985 4.22729 3.21447 5.47672 2.60897 6.93853C2.00347 8.40034 1.84504 10.0089 2.15372 11.5607C2.4624 13.1126 3.22433 14.538 4.34315 15.6569C5.46197 16.7757 6.88743 17.5376 8.43928 17.8463C9.99113 18.155 11.5997 17.9965 13.0615 17.391C14.5233 16.7855 15.7727 15.7602 16.6518 14.4446C17.5308 13.129 18 11.5822 18 10C17.9978 7.87895 17.1542 5.84542 15.6544 4.34562C14.1546 2.84581 12.121 2.00224 10 2ZM10 16.7692C8.66117 16.7692 7.35241 16.3722 6.23922 15.6284C5.12603 14.8846 4.2584 13.8274 3.74605 12.5905C3.2337 11.3536 3.09965 9.99249 3.36084 8.67939C3.62203 7.36629 4.26674 6.16012 5.21343 5.21343C6.16013 4.26674 7.36629 3.62203 8.67939 3.36084C9.99249 3.09965 11.3536 3.2337 12.5905 3.74605C13.8274 4.25839 14.8846 5.12602 15.6284 6.23922C16.3722 7.35241 16.7692 8.66117 16.7692 10C16.7672 11.7947 16.0534 13.5153 14.7843 14.7843C13.5153 16.0534 11.7947 16.7672 10 16.7692ZM13.6923 10C13.6923 10.1632 13.6275 10.3197 13.5121 10.4351C13.3967 10.5505 13.2401 10.6154 13.0769 10.6154H10.6154V13.0769C10.6154 13.2401 10.5506 13.3967 10.4351 13.5121C10.3197 13.6275 10.1632 13.6923 10 13.6923C9.83679 13.6923 9.68027 13.6275 9.56486 13.5121C9.44945 13.3967 9.38462 13.2401 9.38462 13.0769V10.6154H6.92308C6.75987 10.6154 6.60334 10.5505 6.48794 10.4351C6.37253 10.3197 6.30769 10.1632 6.30769 10C6.30769 9.83679 6.37253 9.68026 6.48794 9.56486C6.60334 9.44945 6.75987 9.38461 6.92308 9.38461H9.38462V6.92308C9.38462 6.75987 9.44945 6.60334 9.56486 6.48793C9.68027 6.37253 9.83679 6.30769 10 6.30769C10.1632 6.30769 10.3197 6.37253 10.4351 6.48793C10.5506 6.60334 10.6154 6.75987 10.6154 6.92308V9.38461H13.0769C13.2401 9.38461 13.3967 9.44945 13.5121 9.56486C13.6275 9.68026 13.6923 9.83679 13.6923 10Z"
            fill={color}
          />
        </svg>
      );
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 2C5.59 2 2 5.59 2 10C2 14.41 5.59 18 10 18C14.41 18 18 14.41 18 10C18 5.59 14.41 2 10 2ZM10 17C6.14 17 3 13.86 3 10C3 6.14 6.14 3 10 3C13.86 3 17 6.14 17 10C17 13.86 13.86 17 10 17Z"
            fill={color}
          />
          <path
            d="M13.12 9.5H10.5V6.88C10.5 6.6 10.28 6.38 10 6.38C9.72 6.38 9.5 6.6 9.5 6.88V9.5H6.88C6.6 9.5 6.38 9.72 6.38 10C6.38 10.28 6.6 10.5 6.88 10.5H9.5V13.12C9.5 13.4 9.72 13.62 10 13.62C10.28 13.62 10.5 13.4 10.5 13.12V10.5H13.12C13.4 10.5 13.62 10.28 13.62 10C13.62 9.72 13.4 9.5 13.12 9.5Z"
            fill={color}
          />
        </svg>
      );
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 3.25C13.4783 3.25 11.0132 3.99777 8.91648 5.39876C6.81975 6.79975 5.18555 8.79103 4.22053 11.1208C3.25552 13.4505 3.00302 16.0141 3.49499 18.4874C3.98695 20.9607 5.20127 23.2325 6.98439 25.0156C8.76751 26.7987 11.0393 28.0131 13.5126 28.505C15.9859 28.997 18.5495 28.7445 20.8792 27.7795C23.209 26.8144 25.2002 25.1802 26.6012 23.0835C28.0022 20.9868 28.75 18.5217 28.75 16C28.746 12.6197 27.4015 9.379 25.0112 6.98877C22.621 4.59854 19.3803 3.25397 16 3.25ZM16 27.25C13.775 27.25 11.5999 26.5902 9.74983 25.354C7.89978 24.1179 6.45784 22.3609 5.60635 20.3052C4.75487 18.2495 4.53208 15.9875 4.96616 13.8052C5.40025 11.6229 6.47171 9.61839 8.04505 8.04505C9.61839 6.47171 11.6229 5.40025 13.8052 4.96617C15.9875 4.53208 18.2495 4.75487 20.3052 5.60636C22.3609 6.45784 24.1179 7.89978 25.354 9.74984C26.5902 11.5999 27.25 13.775 27.25 16C27.2467 18.9827 26.0604 21.8422 23.9513 23.9513C21.8422 26.0604 18.9827 27.2467 16 27.25ZM21.75 16C21.75 16.1989 21.671 16.3897 21.5303 16.5303C21.3897 16.671 21.1989 16.75 21 16.75H16.75V21C16.75 21.1989 16.671 21.3897 16.5303 21.5303C16.3897 21.671 16.1989 21.75 16 21.75C15.8011 21.75 15.6103 21.671 15.4697 21.5303C15.329 21.3897 15.25 21.1989 15.25 21V16.75H11C10.8011 16.75 10.6103 16.671 10.4697 16.5303C10.329 16.3897 10.25 16.1989 10.25 16C10.25 15.8011 10.329 15.6103 10.4697 15.4697C10.6103 15.329 10.8011 15.25 11 15.25H15.25V11C15.25 10.8011 15.329 10.6103 15.4697 10.4697C15.6103 10.329 15.8011 10.25 16 10.25C16.1989 10.25 16.3897 10.329 16.5303 10.4697C16.671 10.6103 16.75 10.8011 16.75 11V15.25H21C21.1989 15.25 21.3897 15.329 21.5303 15.4697C21.671 15.6103 21.75 15.8011 21.75 16Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default PlusCircleIcon;
